var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=ScreenSize, colour=Primary, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aspect_ratio",
    d: "M14.8295 17H19.8295V12H17.8295V15H14.8295V17ZM5.82953 12H7.82953V9H10.8295V7H5.82953V12ZM4.82953 20C4.27953 20 3.8087 19.8042 3.41703 19.4125C3.02536 19.0208 2.82953 18.55 2.82953 18V6C2.82953 5.45 3.02536 4.97917 3.41703 4.5875C3.8087 4.19583 4.27953 4 4.82953 4H20.8295C21.3795 4 21.8504 4.19583 22.242 4.5875C22.6337 4.97917 22.8295 5.45 22.8295 6V18C22.8295 18.55 22.6337 19.0208 22.242 19.4125C21.8504 19.8042 21.3795 20 20.8295 20H4.82953ZM4.82953 18H20.8295V6H4.82953V18Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenSize);
export default __webpack_public_path__ + "static/media/ScreenSize.9d6d8df833af87b9844fedc2e3317817.svg";
export { ForwardRef as ReactComponent };